/*global AmCharts, App */

Components.Energy.Manager.TimeCompareChart = function (container, loadDataLink, mediumUnit) {
    /* private */
    var _chart;
    var zoomOut = function() {
        try {
            _chart.zoomOut();
        } catch (e) {
        }
    };
    var prepareDataForChart = function (rawData) {
        var dataProvider = [];
        var intervalA = rawData.intervalA, intervalB = rawData.intervalB;
        var maxLength = intervalA.length > intervalB.length ? intervalA.length : intervalB.length;
        for (var i = 0; i < maxLength; i++) {
            var record = {date: ""};
            if (intervalA[i]) {
                record.intervalA = intervalA[i].powerConsumptionActive;
                record.date += intervalA[i].formatedDateTime;
                record.timestamp = intervalA[i].timestamp;
            }
            if (intervalB[i]) {
                record.intervalB = intervalB[i].powerConsumptionActive;
                record.date += "\n";
                record.date += intervalB[i].formatedDateTime;
            }
            dataProvider.push(record);
        }
        if (rawData.intervalATitle) {
            _chart.graphs[0].title = rawData.intervalATitle;
        }
        if (rawData.intervalBTitle) {
            _chart.graphs[1].title = rawData.intervalBTitle;
        }
        _chart.dataProvider = dataProvider;
        if (dataProvider.length == 0) return _chart.clear();
        _chart.validateData();
        setTimeout(zoomOut, 250);
    };
    var loadData = function () {
        App.Ui.widgetBlock($(_chart.containerDiv));
        $.ajax({
            dataType: "json",
            url: loadDataLink,
            complete: function () {
                App.Ui.widgetBlock($(_chart.containerDiv), "stop");
            },
            success: function (result) {
                if (result.intervalA && result.intervalB) {
                    prepareDataForChart(result);
                } else {
                    App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
                }
            },
            error: function () {
                App.Ui.flashMessage(App.Ui.messages.unavailableData, "info");
            }
        });
    };
    var createChart = function () {
        _chart = new AmCharts.AmSerialChart();
        _chart.theme = "destiny";
        _chart.colors = App.Ui.getColors();
        _chart.language = "cz";
        _chart.pathToImages = "/dist/amcharts/images/";
        _chart.export = App.Charts.export;
        _chart.usePrefixes = true;
        _chart.autoMargins = false;
        _chart.marginLeft = 70;
        _chart.marginRight = 0;
        _chart.marginBottom = 0;
        _chart.zoomOutText = "";
        _chart.categoryField = "date";

        var graphA = new AmCharts.AmGraph();
        graphA.balloonText = "[[title]]: <b>[[value]]Wh</b>";
        graphA.type = "step";
        graphA.title = "První interval";
        graphA.valueField = "intervalA";
        graphA.lineThickness = 1.5;

        var graphB = new AmCharts.AmGraph();
        graphB.balloonText = "[[title]]: <b>[[value]]Wh</b>";
        graphB.type = "step";
        graphB.title = "Druhý interval";
        graphB.valueField = "intervalB";
        graphB.lineThickness = 1.5;

        _chart.addGraph(graphA);
        _chart.addGraph(graphB);

        var valueAxis = new AmCharts.ValueAxis();
        valueAxis.unit = mediumUnit;
        _chart.addValueAxis(valueAxis);

        var categoryAxis = new AmCharts.CategoryAxis();
        categoryAxis.equalSpacing = true;
        categoryAxis.labelFrequency = 3;
        _chart.categoryAxis = categoryAxis;

        var cursor = new AmCharts.ChartCursor();
        cursor.valueLineEnabled = true;
        cursor.valueLineBalloonEnabled = true;
        cursor.zoomable = true;
        cursor.fullWidth = true;
        cursor.cursorAlpha = 0.05;
        cursor.valueLineAlpha = 0.5;
        _chart.addChartCursor(cursor);

        var scrollbar = new AmCharts.ChartScrollbar();
        scrollbar.graph = graphA;
        scrollbar.oppositeAxis = false;
        scrollbar.offset = 50;
        scrollbar.scrollbarHeight = 40;
        _chart.chartScrollbar = scrollbar;

        _chart.write(container);
        loadData();
    };
    var zoomToHour = function () {
        if (_chart.dataProvider.length === 0)
            return false;
        var startDate = new Date(_chart.dataProvider[0].timestamp * 1000);
        for (var i = 0; i < _chart.dataProvider.length; i++) {
            var endDate = new Date(_chart.dataProvider[i].timestamp * 1000);
            if (endDate.getTime() - startDate.getTime() >= 1 * 60 * 60 * 1000)
                break;
        }
        if (i < 1)
            i = 1;
        _chart.zoomToIndexes(0, i - 1);
        inactive();
        $("#" + container + "_zoomToHour").addClass("active");
    };
    var zoomToDay = function () {
        if (_chart.dataProvider.length === 0)
            return false;
        var startDate = new Date(_chart.dataProvider[0].timestamp * 1000);
        for (var i = 0; i < _chart.dataProvider.length; i++) {
            var endDate = new Date(_chart.dataProvider[i].timestamp * 1000);
            if (endDate.getTime() - startDate.getTime() >= 1 * 24 * 60 * 60 * 1000)
                break;
        }
        if (i < 1)
            i = 1;
        _chart.zoomToIndexes(0, i - 1);
        inactive();
        $("#" + container + "_zoomToDay").addClass("active");
    };
    var zoomMax = function () {
        zoomOut();
        inactive();
        $("#" + container + "_zoomMax").addClass("active");
    };
    var inactive = function() {
        $("#" + container + "_zoomToHour").removeClass("active");
        $("#" + container + "_zoomToDay").removeClass("active");
        $("#" + container + "_zoomMax").removeClass("active");
    };
    /* public */
    /* contructor */
    createChart();
    $("#" + container + "_zoomToHour").click(zoomToHour);
    $("#" + container + "_zoomToDay").click(zoomToDay);
    $("#" + container + "_zoomMax").click(zoomMax);
};
